// Blog articles in all languages
export const blogArticles = {
  fr: [
    {
      slug: "intelligence-artificielle-revolutionne-rencontres",
      title: "Comment l'Intelligence Artificielle Révolutionne les Rencontres en Ligne",
      excerpt: "Découvrez comment l'IA transforme le monde du dating en analysant la personnalité pour créer des matchs plus authentiques et durables.",
      date: "30 Janvier 2025",
      readTime: "5 min",
      category: "Technologie",
      image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80"
    },
    {
      slug: "conseils-premier-rendez-vous-reussi",
      title: "10 Conseils pour un Premier Rendez-Vous Réussi",
      excerpt: "Des astuces pratiques pour faire bonne impression lors de votre premier rendez-vous et créer une connexion authentique dès le départ.",
      date: "28 Janvier 2025",
      readTime: "7 min",
      category: "Conseils",
      image: "https://images.unsplash.com/photo-1511895426328-dc8714191300?w=800&q=80"
    },
    {
      slug: "psychologie-compatibilite-amoureuse",
      title: "La Psychologie de la Compatibilité Amoureuse",
      excerpt: "Qu'est-ce qui fait qu'une relation fonctionne ? Explorez les bases scientifiques de la compatibilité entre deux personnes.",
      date: "25 Janvier 2025",
      readTime: "8 min",
      category: "Psychologie",
      image: "https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?w=800&q=80"
    },
    {
      slug: "erreurs-eviter-rencontres-en-ligne",
      title: "Les 7 Erreurs à Éviter dans les Rencontres en Ligne",
      excerpt: "Découvrez les erreurs les plus communes que font les utilisateurs d'applications de rencontre et comment les éviter pour maximiser vos chances.",
      date: "22 Janvier 2025",
      readTime: "6 min",
      category: "Conseils",
      image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&q=80"
    },
    {
      slug: "creer-profil-dating-irresistible",
      title: "Comment Créer un Profil de Dating Irrésistible",
      excerpt: "Guide complet pour rédiger une bio captivante, choisir les bonnes photos et se démarquer sur les applications de rencontre.",
      date: "20 Janvier 2025",
      readTime: "9 min",
      category: "Conseils",
      image: "https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=800&q=80"
    },
    {
      slug: "signes-relation-saine-equilibree",
      title: "Les Signes d'une Relation Saine et Équilibrée",
      excerpt: "Apprenez à reconnaître les indicateurs d'une relation épanouie et découvrez comment cultiver un partenariat équilibré et durable.",
      date: "18 Janvier 2025",
      readTime: "7 min",
      category: "Relations",
      image: "https://images.unsplash.com/photo-1518568814500-bf0f8d125f46?w=800&q=80"
    },
    {
      slug: "10-questions-personnalite-amoureuse",
      title: "10 Questions pour Révéler Votre Personnalité Amoureuse",
      excerpt: "Explorez les questions essentielles qui révèlent votre véritable personnalité en amour et ce que vous recherchez vraiment chez un partenaire.",
      date: "15 Janvier 2025",
      readTime: "6 min",
      category: "Psychologie",
      image: "https://images.unsplash.com/photo-1494059980473-813e73ee784b?w=800&q=80"
    },
    {
      slug: "ia-meilleure-que-tinder",
      title: "Pourquoi l'IA est Meilleure que Tinder pour Trouver l'Amour",
      excerpt: "Comparaison détaillée entre les applications de swipe traditionnelles et les nouvelles plateformes de dating assistées par l'intelligence artificielle.",
      date: "12 Janvier 2025",
      readTime: "8 min",
      category: "Technologie",
      image: "https://images.unsplash.com/photo-1531746790731-6c087fecd65a?w=800&q=80"
    },
    {
      slug: "temoignage-couple-amore-ai",
      title: "Ils se Sont Rencontrés grâce à Amore AI",
      excerpt: "L'histoire touchante de Sophie et Marc qui ont trouvé l'amour grâce à notre plateforme de rencontres basée sur l'IA.",
      date: "8 Janvier 2025",
      readTime: "5 min",
      category: "Témoignages",
      image: "https://images.unsplash.com/photo-1522673607211-8c8f82e01b38?w=800&q=80"
    },
    {
      slug: "trois-piliers-relation-saine",
      title: "Les Trois Piliers d'une Relation Saine : Communication, Confiance et Compromis",
      excerpt: "Découvrez les trois fondements essentiels qui permettent de construire et maintenir une relation amoureuse épanouie et durable.",
      date: "5 Janvier 2025",
      readTime: "8 min",
      category: "Relations",
      image: "https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?w=800&q=80"
    },
    {
      slug: "meilleure-application-rencontre-ia-2026",
      title: "Meilleure Application de Rencontre avec IA en 2026 : Le Guide Complet",
      excerpt: "Quelle est la meilleure application de rencontre avec IA en 2026 ? Découvrez les critères essentiels et pourquoi l'IA révolutionne la recherche de l'amour.",
      date: "10 Juin 2026",
      readTime: "7 min",
      category: "Technologie",
      image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80"
    },
    {
      slug: "test-compatibilite-amoureuse",
      title: "Test de Compatibilité Amoureuse : Comment la Science Prédit l'Amour",
      excerpt: "Peut-on prédire l'amour ? Découvrez comment un test de compatibilité amoureuse basé sur la science et l'IA évalue vos chances de relation durable.",
      date: "8 Juin 2026",
      readTime: "6 min",
      category: "Psychologie",
      image: "https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?w=800&q=80"
    },
    {
      slug: "trouver-amour-en-ligne-guide",
      title: "Comment Trouver l'Amour en Ligne en 2026 : Guide Étape par Étape",
      excerpt: "Le guide complet pour trouver l'amour en ligne en 2026 : choisir la bonne application, optimiser son profil et transformer un match en relation durable.",
      date: "5 Juin 2026",
      readTime: "8 min",
      category: "Conseils",
      image: "https://images.unsplash.com/photo-1511895426328-dc8714191300?w=800&q=80"
    }
  ],
  en: [
    {
      slug: "intelligence-artificielle-revolutionne-rencontres",
      title: "How Artificial Intelligence is Revolutionizing Online Dating",
      excerpt: "Discover how AI transforms the dating world by analyzing personality to create more authentic and lasting matches.",
      date: "January 30, 2025",
      readTime: "5 min",
      category: "Technology",
      image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80"
    },
    {
      slug: "conseils-premier-rendez-vous-reussi",
      title: "10 Tips for a Successful First Date",
      excerpt: "Practical tips to make a good impression on your first date and create an authentic connection from the start.",
      date: "January 28, 2025",
      readTime: "7 min",
      category: "Tips",
      image: "https://images.unsplash.com/photo-1511895426328-dc8714191300?w=800&q=80"
    },
    {
      slug: "psychologie-compatibilite-amoureuse",
      title: "The Psychology of Romantic Compatibility",
      excerpt: "What makes a relationship work? Explore the scientific foundations of compatibility between two people.",
      date: "January 25, 2025",
      readTime: "8 min",
      category: "Psychology",
      image: "https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?w=800&q=80"
    },
    {
      slug: "erreurs-eviter-rencontres-en-ligne",
      title: "7 Mistakes to Avoid in Online Dating",
      excerpt: "Discover the most common mistakes dating app users make and how to avoid them to maximize your chances.",
      date: "January 22, 2025",
      readTime: "6 min",
      category: "Tips",
      image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&q=80"
    },
    {
      slug: "creer-profil-dating-irresistible",
      title: "How to Create an Irresistible Dating Profile",
      excerpt: "Complete guide to writing a captivating bio, choosing the right photos, and standing out on dating apps.",
      date: "January 20, 2025",
      readTime: "9 min",
      category: "Tips",
      image: "https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=800&q=80"
    },
    {
      slug: "signes-relation-saine-equilibree",
      title: "Signs of a Healthy and Balanced Relationship",
      excerpt: "Learn to recognize the indicators of a fulfilling relationship and discover how to cultivate a balanced and lasting partnership.",
      date: "January 18, 2025",
      readTime: "7 min",
      category: "Relationships",
      image: "https://images.unsplash.com/photo-1518568814500-bf0f8d125f46?w=800&q=80"
    },
    {
      slug: "10-questions-personnalite-amoureuse",
      title: "10 Questions to Reveal Your Love Personality",
      excerpt: "Explore the essential questions that reveal your true personality in love and what you really seek in a partner.",
      date: "January 15, 2025",
      readTime: "6 min",
      category: "Psychology",
      image: "https://images.unsplash.com/photo-1494059980473-813e73ee784b?w=800&q=80"
    },
    {
      slug: "ia-meilleure-que-tinder",
      title: "Why AI is Better than Tinder for Finding Love",
      excerpt: "Detailed comparison between traditional swipe apps and new AI-assisted dating platforms.",
      date: "January 12, 2025",
      readTime: "8 min",
      category: "Technology",
      image: "https://images.unsplash.com/photo-1531746790731-6c087fecd65a?w=800&q=80"
    },
    {
      slug: "temoignage-couple-amore-ai",
      title: "They Met Thanks to Amore AI",
      excerpt: "The touching story of Sophie and Marc who found love through our AI-based dating platform.",
      date: "January 8, 2025",
      readTime: "5 min",
      category: "Testimonials",
      image: "https://images.unsplash.com/photo-1522673607211-8c8f82e01b38?w=800&q=80"
    },
    {
      slug: "trois-piliers-relation-saine",
      title: "The Three Pillars of a Healthy Relationship: Communication, Trust and Compromise",
      excerpt: "Discover the three essential foundations that allow you to build and maintain a fulfilling and lasting romantic relationship.",
      date: "January 5, 2025",
      readTime: "8 min",
      category: "Relationships",
      image: "https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?w=800&q=80"
    },
    {
      slug: "meilleure-application-rencontre-ia-2026",
      title: "Best AI Dating App in 2026: The Complete Guide",
      excerpt: "What is the best AI dating app in 2026? Discover the key criteria and why artificial intelligence is revolutionizing the search for love.",
      date: "June 10, 2026",
      readTime: "7 min",
      category: "Technology",
      image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80"
    },
    {
      slug: "test-compatibilite-amoureuse",
      title: "Love Compatibility Test: How Science Predicts Love",
      excerpt: "Can love be predicted? Discover how a science- and AI-based love compatibility test assesses your chances of a lasting relationship.",
      date: "June 8, 2026",
      readTime: "6 min",
      category: "Psychology",
      image: "https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?w=800&q=80"
    },
    {
      slug: "trouver-amour-en-ligne-guide",
      title: "How to Find Love Online in 2026: A Step-by-Step Guide",
      excerpt: "The complete guide to finding love online in 2026: choosing the right app, optimizing your profile and turning a match into a lasting relationship.",
      date: "June 5, 2026",
      readTime: "8 min",
      category: "Tips",
      image: "https://images.unsplash.com/photo-1511895426328-dc8714191300?w=800&q=80"
    }
  ],
  es: [
    {
      slug: "intelligence-artificielle-revolutionne-rencontres",
      title: "Cómo la Inteligencia Artificial Revoluciona las Citas en Línea",
      excerpt: "Descubre cómo la IA transforma el mundo de las citas analizando la personalidad para crear coincidencias más auténticas y duraderas.",
      date: "30 de enero de 2025",
      readTime: "5 min",
      category: "Tecnología",
      image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80"
    },
    {
      slug: "conseils-premier-rendez-vous-reussi",
      title: "10 Consejos para una Primera Cita Exitosa",
      excerpt: "Consejos prácticos para causar una buena impresión en tu primera cita y crear una conexión auténtica desde el principio.",
      date: "28 de enero de 2025",
      readTime: "7 min",
      category: "Consejos",
      image: "https://images.unsplash.com/photo-1511895426328-dc8714191300?w=800&q=80"
    },
    {
      slug: "psychologie-compatibilite-amoureuse",
      title: "La Psicología de la Compatibilidad Romántica",
      excerpt: "¿Qué hace que una relación funcione? Explora las bases científicas de la compatibilidad entre dos personas.",
      date: "25 de enero de 2025",
      readTime: "8 min",
      category: "Psicología",
      image: "https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?w=800&q=80"
    },
    {
      slug: "erreurs-eviter-rencontres-en-ligne",
      title: "7 Errores a Evitar en las Citas en Línea",
      excerpt: "Descubre los errores más comunes que cometen los usuarios de aplicaciones de citas y cómo evitarlos para maximizar tus posibilidades.",
      date: "22 de enero de 2025",
      readTime: "6 min",
      category: "Consejos",
      image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&q=80"
    },
    {
      slug: "creer-profil-dating-irresistible",
      title: "Cómo Crear un Perfil de Citas Irresistible",
      excerpt: "Guía completa para escribir una biografía cautivadora, elegir las fotos correctas y destacar en las aplicaciones de citas.",
      date: "20 de enero de 2025",
      readTime: "9 min",
      category: "Consejos",
      image: "https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=800&q=80"
    },
    {
      slug: "signes-relation-saine-equilibree",
      title: "Señales de una Relación Sana y Equilibrada",
      excerpt: "Aprende a reconocer los indicadores de una relación satisfactoria y descubre cómo cultivar una asociación equilibrada y duradera.",
      date: "18 de enero de 2025",
      readTime: "7 min",
      category: "Relaciones",
      image: "https://images.unsplash.com/photo-1518568814500-bf0f8d125f46?w=800&q=80"
    },
    {
      slug: "10-questions-personnalite-amoureuse",
      title: "10 Preguntas para Revelar Tu Personalidad Amorosa",
      excerpt: "Explora las preguntas esenciales que revelan tu verdadera personalidad en el amor y lo que realmente buscas en una pareja.",
      date: "15 de enero de 2025",
      readTime: "6 min",
      category: "Psicología",
      image: "https://images.unsplash.com/photo-1494059980473-813e73ee784b?w=800&q=80"
    },
    {
      slug: "ia-meilleure-que-tinder",
      title: "Por Qué la IA es Mejor que Tinder para Encontrar el Amor",
      excerpt: "Comparación detallada entre las aplicaciones de swipe tradicionales y las nuevas plataformas de citas asistidas por inteligencia artificial.",
      date: "12 de enero de 2025",
      readTime: "8 min",
      category: "Tecnología",
      image: "https://images.unsplash.com/photo-1531746790731-6c087fecd65a?w=800&q=80"
    },
    {
      slug: "temoignage-couple-amore-ai",
      title: "Se Conocieron Gracias a Amore AI",
      excerpt: "La conmovedora historia de Sophie y Marc que encontraron el amor a través de nuestra plataforma de citas basada en IA.",
      date: "8 de enero de 2025",
      readTime: "5 min",
      category: "Testimonios",
      image: "https://images.unsplash.com/photo-1522673607211-8c8f82e01b38?w=800&q=80"
    },
    {
      slug: "trois-piliers-relation-saine",
      title: "Los Tres Pilares de una Relación Sana: Comunicación, Confianza y Compromiso",
      excerpt: "Descubre los tres fundamentos esenciales que permiten construir y mantener una relación amorosa plena y duradera.",
      date: "5 de enero de 2025",
      readTime: "8 min",
      category: "Relaciones",
      image: "https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?w=800&q=80"
    },
    {
      slug: "meilleure-application-rencontre-ia-2026",
      title: "Mejor App de Citas con IA en 2026: La Guía Completa",
      excerpt: "¿Cuál es la mejor app de citas con IA en 2026? Descubre los criterios clave y por qué la inteligencia artificial revoluciona la búsqueda del amor.",
      date: "10 de junio de 2026",
      readTime: "7 min",
      category: "Tecnología",
      image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80"
    },
    {
      slug: "test-compatibilite-amoureuse",
      title: "Test de Compatibilidad Amorosa: Cómo la Ciencia Predice el Amor",
      excerpt: "¿Se puede predecir el amor? Descubre cómo un test de compatibilidad amorosa basado en la ciencia y la IA evalúa tus posibilidades de una relación duradera.",
      date: "8 de junio de 2026",
      readTime: "6 min",
      category: "Psicología",
      image: "https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?w=800&q=80"
    },
    {
      slug: "trouver-amour-en-ligne-guide",
      title: "Cómo Encontrar el Amor en Línea en 2026: Guía Paso a Paso",
      excerpt: "La guía completa para encontrar el amor en línea en 2026: elegir la app correcta, optimizar tu perfil y convertir un match en una relación duradera.",
      date: "5 de junio de 2026",
      readTime: "8 min",
      category: "Consejos",
      image: "https://images.unsplash.com/photo-1511895426328-dc8714191300?w=800&q=80"
    }
  ],
  de: [
    {
      slug: "intelligence-artificielle-revolutionne-rencontres",
      title: "Wie Künstliche Intelligenz Online-Dating Revolutioniert",
      excerpt: "Entdecken Sie, wie KI die Dating-Welt verwandelt, indem sie Persönlichkeiten analysiert, um authentischere und dauerhaftere Matches zu schaffen.",
      date: "30. Januar 2025",
      readTime: "5 Min",
      category: "Technologie",
      image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80"
    },
    {
      slug: "conseils-premier-rendez-vous-reussi",
      title: "10 Tipps für ein Erfolgreiches Erstes Date",
      excerpt: "Praktische Tipps, um beim ersten Date einen guten Eindruck zu machen und von Anfang an eine authentische Verbindung zu schaffen.",
      date: "28. Januar 2025",
      readTime: "7 Min",
      category: "Tipps",
      image: "https://images.unsplash.com/photo-1511895426328-dc8714191300?w=800&q=80"
    },
    {
      slug: "psychologie-compatibilite-amoureuse",
      title: "Die Psychologie der Romantischen Kompatibilität",
      excerpt: "Was lässt eine Beziehung funktionieren? Erforschen Sie die wissenschaftlichen Grundlagen der Kompatibilität zwischen zwei Menschen.",
      date: "25. Januar 2025",
      readTime: "8 Min",
      category: "Psychologie",
      image: "https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?w=800&q=80"
    },
    {
      slug: "erreurs-eviter-rencontres-en-ligne",
      title: "7 Fehler, die Sie beim Online-Dating Vermeiden Sollten",
      excerpt: "Entdecken Sie die häufigsten Fehler, die Dating-App-Nutzer machen, und wie Sie diese vermeiden können, um Ihre Chancen zu maximieren.",
      date: "22. Januar 2025",
      readTime: "6 Min",
      category: "Tipps",
      image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&q=80"
    },
    {
      slug: "creer-profil-dating-irresistible",
      title: "Wie Man ein Unwiderstehliches Dating-Profil Erstellt",
      excerpt: "Vollständiger Leitfaden zum Verfassen einer fesselnden Biografie, Auswahl der richtigen Fotos und Hervorhebung in Dating-Apps.",
      date: "20. Januar 2025",
      readTime: "9 Min",
      category: "Tipps",
      image: "https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=800&q=80"
    },
    {
      slug: "signes-relation-saine-equilibree",
      title: "Anzeichen einer Gesunden und Ausgewogenen Beziehung",
      excerpt: "Lernen Sie, die Indikatoren einer erfüllenden Beziehung zu erkennen und entdecken Sie, wie Sie eine ausgewogene und dauerhafte Partnerschaft pflegen.",
      date: "18. Januar 2025",
      readTime: "7 Min",
      category: "Beziehungen",
      image: "https://images.unsplash.com/photo-1518568814500-bf0f8d125f46?w=800&q=80"
    },
    {
      slug: "10-questions-personnalite-amoureuse",
      title: "10 Fragen, um Ihre Liebespersönlichkeit zu Enthüllen",
      excerpt: "Erkunden Sie die wesentlichen Fragen, die Ihre wahre Persönlichkeit in der Liebe offenbaren und was Sie wirklich bei einem Partner suchen.",
      date: "15. Januar 2025",
      readTime: "6 Min",
      category: "Psychologie",
      image: "https://images.unsplash.com/photo-1494059980473-813e73ee784b?w=800&q=80"
    },
    {
      slug: "ia-meilleure-que-tinder",
      title: "Warum KI Besser als Tinder ist, um die Liebe zu Finden",
      excerpt: "Detaillierter Vergleich zwischen traditionellen Swipe-Apps und neuen KI-gestützten Dating-Plattformen.",
      date: "12. Januar 2025",
      readTime: "8 Min",
      category: "Technologie",
      image: "https://images.unsplash.com/photo-1531746790731-6c087fecd65a?w=800&q=80"
    },
    {
      slug: "temoignage-couple-amore-ai",
      title: "Sie Trafen Sich Dank Amore AI",
      excerpt: "Die berührende Geschichte von Sophie und Marc, die durch unsere KI-basierte Dating-Plattform die Liebe fanden.",
      date: "8. Januar 2025",
      readTime: "5 Min",
      category: "Erfahrungsberichte",
      image: "https://images.unsplash.com/photo-1522673607211-8c8f82e01b38?w=800&q=80"
    },
    {
      slug: "trois-piliers-relation-saine",
      title: "Die Drei Säulen einer Gesunden Beziehung: Kommunikation, Vertrauen und Kompromiss",
      excerpt: "Entdecken Sie die drei wesentlichen Grundlagen, die es ermöglichen, eine erfüllende und dauerhafte romantische Beziehung aufzubauen und zu pflegen.",
      date: "5. Januar 2025",
      readTime: "8 Min",
      category: "Beziehungen",
      image: "https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?w=800&q=80"
    },
    {
      slug: "meilleure-application-rencontre-ia-2026",
      title: "Beste KI-Dating-App 2026: Der Komplette Leitfaden",
      excerpt: "Was ist die beste KI-Dating-App 2026? Entdecken Sie die wichtigsten Kriterien und warum künstliche Intelligenz die Partnersuche revolutioniert.",
      date: "10. Juni 2026",
      readTime: "7 Min",
      category: "Technologie",
      image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80"
    },
    {
      slug: "test-compatibilite-amoureuse",
      title: "Liebeskompatibilitätstest: Wie die Wissenschaft die Liebe Vorhersagt",
      excerpt: "Lässt sich Liebe vorhersagen? Erfahren Sie, wie ein wissenschafts- und KI-basierter Kompatibilitätstest Ihre Chancen auf eine dauerhafte Beziehung bewertet.",
      date: "8. Juni 2026",
      readTime: "6 Min",
      category: "Psychologie",
      image: "https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?w=800&q=80"
    },
    {
      slug: "trouver-amour-en-ligne-guide",
      title: "Wie Man 2026 Online die Liebe Findet: Eine Schritt-für-Schritt-Anleitung",
      excerpt: "Der komplette Leitfaden, um 2026 online die Liebe zu finden: die richtige App wählen, das Profil optimieren und aus einem Match eine dauerhafte Beziehung machen.",
      date: "5. Juni 2026",
      readTime: "8 Min",
      category: "Tipps",
      image: "https://images.unsplash.com/photo-1511895426328-dc8714191300?w=800&q=80"
    }
  ]
};
